import React, { useState } from "react";
import useAuthEffect from "../../../hook/useAuthEffect";
import axios from "axios";

const UserRoleSelect = props => {

    const [roles, setRoles] = useState([]);

    useAuthEffect(() => {
        axios
            .get(`${window.API_URL}/user/getRoles.php`)
            .then(result => {
                setRoles(result.data.data)
            });
    });

    return (
        <select name={props.name} className={"select select--primary " + props.className} onChange={props.onChange}>

            <option selected disabled></option>
            {
                roles.map(role =>
                    <option value={role}>{role}</option>
                )
            }
        </select>
    )
}

export default UserRoleSelect;